/**
 * Creates a Shopify GID from a given ID and resource type.
 * Hydrogen gives a `parseGid` function, but no `createGid` function.
 */
export function createShopifyGID(id: number, resourceType: string): string {
  return `gid://shopify/${resourceType}/${id}`;
}
